import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { DateRange } from 'foundations-components/transitional/components/DateRange';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { HelpIcon } from 'foundations-components/transitional/components/HelpIcon';
import { RadioInput } from 'foundations-components/transitional/components/RadioInput';
import { LAST_MONTH } from 'foundations-components/transitional/components/Dates';
import { Component } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
class ManageExportTimeRangeSelect extends Component {
  renderTimeRangeSelect() {
    const {
      value,
      onChange
    } = this.props;
    return /*#__PURE__*/_jsx(DateRange, {
      onChange: ({
        target
      }) => {
        onChange({
          presetId: target.value.presetId,
          startDate: target.value.startDate,
          endDate: target.value.endDate
        });
      },
      tz: "portalTz",
      value: {
        presetId: value.presetId,
        startDate: value.startDate,
        endDate: value.endDate
      }
    });
  }
  renderRadioInput(isTime = false) {
    const message = isTime ? 'email-management.modals.export.timeRangeRadio' : 'email-management.modals.export.allEmailRadio';
    return /*#__PURE__*/_jsx(RadioInput, {
      defaultChecked: !isTime,
      name: "emailExportRadio",
      onChange: () => {
        if (isTime) {
          this.props.onChange(Object.assign({
            presetId: LAST_MONTH.presetId
          }, LAST_MONTH.getValue('portalTz')));
        } else {
          this.props.onChange({
            presetId: undefined
          });
        }
      },
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: message
      })
    });
  }
  render() {
    const {
      presetId,
      startDate,
      endDate
    } = this.props.value;
    return /*#__PURE__*/_jsx(FormControl, {
      "data-test-id": "export-date-field",
      label: /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "email-management.modals.export.exportTypeLabel"
        }), /*#__PURE__*/_jsx(HelpIcon, {
          title: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "email-management.modals.export.exportDateTooltip"
          }),
          tooltipPlacement: "right",
          marginInlineStart: "100"
        })]
      }),
      children: /*#__PURE__*/_jsxs("span", {
        children: [this.renderRadioInput(), this.renderRadioInput(true), (presetId || startDate && endDate) && this.renderTimeRangeSelect()]
      })
    });
  }
}
ManageExportTimeRangeSelect.defaultProps = {
  value: {
    presetId: undefined
  }
};
export default ManageExportTimeRangeSelect;